import React from "react";
import Loading from "../components/Loading";
import NoData from "../components/NoData";
import { useTranslation } from 'react-i18next';


export default function NotFound(){
    const { t } = useTranslation();

    return(
        <div>
            <div className="floatCenter">
                <NoData text="페이지를 찾을 수 없습니다 .. 😥"/>
            </div>
        </div>
    );
};